import { partnerLogos } from "../../data/partnerData";

function PartnerMarquee() {
  return (
    <section
      className="w-full overflow-hidden border-b border-slate-200 bg-white py-7 md:py-11"
      aria-label="Rental partners"
    >
      {/* 
        flex and overflow-hidden ensure the items stay in a single row 
        You can add 'group' here and 'group-hover:paused' to the children if you want it to pause on hover
      */}
      <div className="flex w-full overflow-hidden whitespace-nowrap">
        {/* First set of logos */}
        <div className="flex w-max animate-infinite-marquee items-center gap-12 pl-12 md:gap-24 md:pl-24 motion-reduce:animate-none motion-reduce:flex-wrap motion-reduce:justify-center">
          {partnerLogos.map((partner, index) => (
            <span
              className={`inline-flex min-w-[90px] items-center justify-center whitespace-nowrap text-lg font-extrabold leading-none text-slate-900 md:min-w-28 ${partner.className}`}
              key={`marquee-1-${partner.name}-${index}`}
            >
              {partner.name}
            </span>
          ))}
        </div>

        {/* Second set of logos (Exact duplicate for seamless looping) */}
        <div
          className="flex w-max animate-infinite-marquee items-center gap-12 pl-12 md:gap-24 md:pl-24 motion-reduce:animate-none motion-reduce:hidden"
          aria-hidden="true"
        >
          {partnerLogos.map((partner, index) => (
            <span
              className={`inline-flex min-w-[90px] items-center justify-center whitespace-nowrap text-lg font-extrabold leading-none text-slate-900 md:min-w-28 ${partner.className}`}
              key={`marquee-2-${partner.name}-${index}`}
            >
              {partner.name}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}

export default PartnerMarquee;
